(function () {
  var NBSP = '\u00A0';

  var RULES = {
    EUR: { t: '.', d: ',', pre: '€' + NBSP, suf: '' },
    SEK: { t: NBSP, d: ',', pre: '', suf: NBSP + 'kr' },
    DKK: { t: '.', d: ',', pre: '', suf: NBSP + 'kr.' },
    NOK: { t: NBSP, d: ',', pre: '', suf: NBSP + 'kr' },
    PLN: { t: '.', d: ',', pre: '', suf: NBSP + 'zł' },
    // AAS-5460 — one CHF format for every Swiss language; see armada-money.liquid.
    CHF: { t: "'", d: '.', pre: 'CHF' + NBSP, suf: '' },
    GBP: { t: ',', d: '.', pre: '£', suf: '' },
    CZK: { t: NBSP, d: ',', pre: '', suf: NBSP + 'Kč' },
    USD: { t: ',', d: '.', pre: '$', suf: '' }
  };

  var legacyFormatMoney = window.formatMoney;

  function activeCurrency() {
    return (
      (window.armadaMoney && window.armadaMoney.currency) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      ''
    ).toUpperCase();
  }

  function activeLanguage() {
    var locale =
      (window.armadaMoney && window.armadaMoney.locale) ||
      document.documentElement.lang ||
      'en';
    return String(locale).slice(0, 2).toLowerCase();
  }

  function ruleFor(iso) {
    if (iso === 'CAD') {
      return activeLanguage() === 'fr'
        ? { t: NBSP, d: ',', pre: '', suf: NBSP + '$' }
        : { t: ',', d: '.', pre: '$', suf: '' };
    }
    return RULES[iso] || null;
  }

  function armadaFormatMoney(cents, opts) {
    if (typeof cents === 'string') {
      var negative = cents.indexOf('-') !== -1;
      cents = Number(cents.replace(/\D/g, '')) * (negative ? -1 : 1);
    }
    cents = Math.round(Number(cents) || 0);

    var iso = ((opts && opts.currency) || activeCurrency()).toUpperCase();
    var rule = ruleFor(iso);

    if (!rule) {
      if (typeof legacyFormatMoney === 'function') {
        var fmt =
          (window.theme &&
            window.theme.settings &&
            window.theme.settings.money_with_currency_format) ||
          '${{amount}}';
        return legacyFormatMoney(cents, fmt);
      }
      return String(cents / 100);
    }

    var sign = cents < 0 ? '-' : '';
    cents = Math.abs(cents);

    var whole = String(Math.floor(cents / 100));
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;

    var grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, rule.t);

    var hideDecimals = opts && opts.trailingZeros === false && frac === '00';
    var number = hideDecimals ? grouped : grouped + rule.d + frac;

    return sign + rule.pre + number + rule.suf;
  }

  window.armadaFormatMoney = armadaFormatMoney;

  window.formatMoney = function (cents) {
    return armadaFormatMoney(cents);
  };
})();
